import { HasIdDisplay } from "~/@shared/api-types/id-name-display"
import { GET } from "~/api/_common/http"

import { FailedInfraResponse } from "../_common/InfraResponse"
import { defineFetcher } from "../_common/defineFetcher"

const PATH = "/long_internship_purpose"

export type GetLongInternshipPurpose = FailedInfraResponse | HasIdDisplay[]

export const fetchGetLongInternshipPurpose = defineFetcher((): Promise<GetLongInternshipPurpose> => {
  return GET(PATH)
})
